






























































































































































import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';

import { MigrationUser } from '@/common/MIgration';

import Staff from '@/services/Staff';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

@Component({
	name: 'StaffMigrationsSingle',
	components: {
		Alert,
		Loading,
		Welcome,
		TextField,
		SelectField,
	},
})
export default class StaffMigrationsSingle extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private user: MigrationUser = undefined;
	private usernameSuccess: boolean = false;
	private usernameError: boolean = false;
	private statusSuccess: boolean = false;
	private statusError: boolean = false;
	private passwordSuccess: boolean = false;
	private passwordError: boolean = false;
	private password: string = '';
	private showPasswordForm: boolean = false;

	private async updatePassword() {
		this.passwordSuccess = false;
		this.passwordError = false;

		if (this.password.length <= 0) {
			this.passwordError = true;
			return;
		}

		const encoder = new TextEncoder();
		const encryptedPassword = await window.crypto.subtle.digest(
			'SHA-256',
			encoder.encode(this.password),
		);

		function hexString(buffer) {
			const byteArray = new Uint8Array(buffer);

			const hexCodes = [...byteArray].map(value => {
				const hexCode = value.toString(16);
				const paddedHexCode = hexCode.padStart(2, '0');
				return paddedHexCode;
			});

			return hexCodes.join('');
		}

		const hexedPassword = hexString(encryptedPassword);

		this.loading = true;
		Staff.updateMigrationPassword(this.$route.params.accountId, hexedPassword)
			.then(({ data }: AxiosResponse) => {
				this.passwordSuccess = true;
				this.loading = false;
				this.password = '';
			})
			.catch(e => {
				console.log(e);
				this.passwordError = true;
				this.loading = false;
			});
	}

	private async updateUsername() {
		this.loading = true;
		Staff.updateMigrationUsername(this.$route.params.accountId, this.user.mmicusername)
			.then(({ data }: AxiosResponse) => {
				this.usernameSuccess = true;
				this.loading = false;
			})
			.catch(e => {
				console.log(e);
				this.usernameError = true;
				this.loading = false;
			});
	}

	private async updateStatus() {
		this.loading = true;
		Staff.updateMigrationStatus(this.$route.params.accountId, this.user.migratestatus)
			.then(({ data }: AxiosResponse) => {
				this.statusSuccess = true;
				this.loading = false;
			})
			.catch(e => {
				console.log(e);
				this.statusSuccess = true;
				this.loading = false;
			});
	}

	private async created() {
		Staff.getMigration(this.$route.params.accountId)
			.then(({ data }: AxiosResponse) => {
				this.user = data;
				this.loading = false;
			})
			.catch(e => {
				console.log(e);
				this.error = true;
				this.loading = false;
			});
	}
}
